import { InitProps } from "./types";
import { UTMSInit } from "./utils/paramsTracker";
import { log } from "./utils/log";

export function init({ enabled, ...options }: InitProps) {
  log({
    debug: options.debug || false,
    message: "Inicializando Params Tracker",
    enabled,
    ...options,
  });

  const utmsInit = new UTMSInit({
    enabled,
    ...options,
  });

  // ✅ Bloqueio global para evitar múltiplas execuções
  if (typeof window !== "undefined" && window.__t3_utms_initialized) {
    log({
      debug: options.debug || false,
      message: "Params Tracker já inicializado. Abortando duplicata.",
    });
    return;
  }

  if (typeof window !== "undefined") {
    window.__t3_utms_initialized = true;
    window.t3_utms = utmsInit;
  }

  return utmsInit;
}

export type { InitProps };
